import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinejoin: 'round' as const
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const
};

export const LocationIcon = createSvgIcon(
  <>
    <path
      d="M3.54393 3.48251C5.1785 1.88064 7.37919 0.988552 9.66779 1.00011C11.9564 1.01167 14.148 1.92594 15.7663 3.54424C17.3846 5.16255 18.2988 7.35412 18.3104 9.64272C18.322 11.9313 17.4299 14.132 15.828 15.7666L11.2368 20.3577C10.8255 20.769 10.2676 21 9.68596 21C9.1043 21 8.54646 20.769 8.1351 20.3577L3.54393 15.7666C1.91507 14.1376 1 11.9282 1 9.62455C1 7.32087 1.91507 5.11154 3.54393 3.48251Z"
      {...strokeProps}
    />
    <path
      d="M9.68588 12.9149C11.5031 12.9149 12.9763 11.4418 12.9763 9.62454C12.9763 7.80732 11.5031 6.33417 9.68588 6.33417C7.86866 6.33417 6.39551 7.80732 6.39551 9.62454C6.39551 11.4418 7.86866 12.9149 9.68588 12.9149Z"
      {...strokePropsRound}
    />
  </>,
  { displayName: 'LocationIcon', viewBox: '0 0 20 22' }
);
